/**
 * Tiny client-side CSV export — no dependency. Quotes any cell containing a
 * comma, quote, or newline (RFC-4180), prepends a BOM so Excel reads UTF-8,
 * and triggers a browser download.
 */

type Cell = string | number | boolean | null | undefined

function csvCell(v: Cell): string {
  if (v === null || v === undefined) return ''
  const s = String(v)
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/** Trigger a browser download for an already-built Blob (e.g. an .xlsx fetched
 * from the backend). */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function downloadCsv(filename: string, headers: string[], rows: Cell[][]): void {
  const lines = [
    headers.map(csvCell).join(','),
    ...rows.map((r) => r.map(csvCell).join(',')),
  ]
  downloadBlob(
    filename,
    new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' }),
  )
}
